import { reduxForm } from 'redux-form';
import validateTool from 'validate.js';
import MatchResultVotingForm from './MatchResultVotingForm';
import MatchResult from '../../../../../api/voting/matchResult';
import { TYPE_MATCH_RESULT } from '../../../../../api/voting/base';
import EventActions from '../../../../../actions/event';
import { convertDate, parseVotingStatuses } from '../helper';

const validate = (data) => {
  return validateTool(data, MatchResult.validateConstraints) || {};
};

const fields = [
  'voting',
  'start_time',
  'end_time'
];

export default reduxForm(
  {
    form: 'match_result_voting_form',
    fields,
    returnRejectedSubmitPromise: true,
    validate
  },
  (state) => {
    let { event } = state;
    let voting = event.model ? event.model.matchResultVoting : null;

    let data = parseVotingStatuses(voting);
    Object.assign(data, {
      initialValues: prepareMatchResultVoting(voting)
    });

    return data;
  },
  (dispatch) => ({
    announceResult: (data) => dispatch(EventActions.announceResultVoting(TYPE_MATCH_RESULT, data)),
    save: (data) => dispatch(EventActions.saveVoting(TYPE_MATCH_RESULT, data)),
    publish: (data) => dispatch(EventActions.publishVoting(TYPE_MATCH_RESULT, data))
  })
)(MatchResultVotingForm);

function prepareMatchResultVoting(voting) {
  if ( voting ) {
    return {
      start_time: convertDate(voting.start_time),
      end_time: convertDate(voting.end_time)
    };
  } else {
    return undefined;
  }
}



// WEBPACK FOOTER //
// ./src/components/Events/EventsEditForm/votings/MatchResultVoting/index.js